import API from "./api";

const MaterialService = {
  // Get materials for a course (with optional parent_id and pagination)
  getMaterials: async (courseId, parentId = null, page = 1, limit = 20) => {
    try {
      let url = `/materials/${courseId}?page=${page}&limit=${limit}`;
      if (parentId) {
        url += `&parent_id=${parentId}`;
      }
      const response = await API.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Move material up
  moveUp: async (courseId, materialId) => {
    try {
      const response = await API.post(`/materials/${courseId}/move-up/${materialId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Move material down
  moveDown: async (courseId, materialId) => {
    try {
      const response = await API.post(`/materials/${courseId}/move-down/${materialId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create new folder
  createFolder: async (courseId, folderData) => {
    try {
      const response = await API.post(`/materials/${courseId}/folder`, folderData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Upload file or add link
  uploadFile: async (courseId, formData) => {
    try {
      const response = await API.post(`/materials/${courseId}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update material (folder name, title, or URL)
  updateMaterial: async (courseId, materialId, updateData) => {
    try {
      const response = await API.put(`/materials/${courseId}/update/${materialId}`, updateData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete material
  deleteMaterial: async (courseId, materialId) => {
    try {
      const response = await API.delete(`/materials/${courseId}/delete/${materialId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get folder path
  getFolderPath: async (courseId, materialId) => {
    try {
      const response = await API.get(`/materials/${courseId}/path/${materialId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get all materials for a course (for adoption)
  getAllMaterialsForCourse: async (courseId) => {
    try {
      const response = await API.get(`/materials/${courseId}/all`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Import materials
  adoptMaterials: async (sourceCourseId, targetCourseId, materialIds, targetParentId = null) => {
    try {
      const payload = {
        source_course_id: sourceCourseId,
        target_course_id: targetCourseId,
        material_ids: materialIds,
      };
      if (targetParentId) {
        payload.target_parent_id = targetParentId;
      }
      const response = await API.post("/materials/adopt", payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get folder item count
  getFolderItemCount: async (courseId, folderId) => {
    try {
      const response = await API.get(`/materials/${courseId}/count/${folderId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default MaterialService;